import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/levels', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/levels', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/levels/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/levels/${data.level_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/levels/${id}`)
    .then(response => Promise.resolve(response.data))
}

export const mainProgram = (Options = {}) => {
  return httpClient
    .get('/api/levels/main-programs', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getSubProgram = (acp_id, Options = {}) => {
  return httpClient
    .get(`/api/levels/${acp_id}/sub-programs`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  find,
  store,
  update,
  destroy,
  mainProgram,
  getSubProgram
}
